import React from "react"
import { Badge } from "react-bootstrap"
import { injectIntl } from "react-intl"
import { Intl } from "../../state/helpers/IntlProps"
import Terminal from "../../state/terminal/Terminal"
import { badgeMessages } from "./BadgeMessages"

type Props = {
    intl: Intl,
    terminal: Terminal,
}

const TerminalBadges = (props: Props) => {
    const getInUseBadge = (): React.ReactElement => {
        return props.terminal.isInUse() ? (
            <Badge variant="danger" key={`${props.terminal.getId()}-in-use`}>
                {props.intl.formatMessage(badgeMessages.inUse)}
            </Badge>
        ) : (
            <Badge variant="success" key={`${props.terminal.getId()}-in-use`}>
                {props.intl.formatMessage(badgeMessages.notInUse)}
            </Badge>
        )
    }

    return (
        <>
            <Badge className="mr-2" variant="success">
                {props.intl.formatMessage(badgeMessages.paired)}
            </Badge>
            {getInUseBadge()}
        </>
    )
}

export default injectIntl(TerminalBadges)


// WEBPACK FOOTER //
// ./src/payment-processing/components/TerminalBadges.tsx